var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{staticClass:"payout-form__form __gusto mt-6",attrs:{"fields":_vm.formFields,"values":_vm.values},on:{"input":_vm.input,"validation":function (v) { return _vm.$emit('validation', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }